export const OOPS_SOMETHING_WENT_WRONG = "Oops Something went wrong!";
export const RETRY = "Retry";
export const LOGIN = "Login";

export const CUTLEY_DATA = {
    title: "I want a no-contact delivery",
    preSelectionSubtitle:
        "Our delivery partner will call (or ring your doorbell) after reaching and leave the order at your door/gate (Not applicable for COD)",
    postSelectionSubtitle:
        "Our delivery partner will call to confirm. Please ensure that your address has all the required details.",
};

export const EMPTY_CART = {
    IMAGE: "CartPageAssets/empty_cart",
    TITLE: "Good Food is Always Cooking",
    MESSAGE: "Your cart is empty. Add something from the menu",
    ACTION: "Browse Restaurants",
    POP_GO_TO_HOME_ACTION: "Go to home",
};

export const TOING_CART_ASSETS = {
    EMPTY_CART: "Toing/Error%20States/Cart%20empty%20state.png",
    CART_ERROR: "Toing/Error%20States/Internal%20Server%20Error.png",
};

export const DEFAULT_API_RETRY_DELAY_TIME_IN_MS = 100;

export const DONT_SEND_CUTLERY = "DONT_SEND_CUTLERY";

export const SOCIAL_OFO_TEXT = {
    editTitle: "You are ordering for :name",
    addPlusTitle: "Ordering for someone else?",
    editSubTitle: "We will share order tracking and delivery communication on :mobile",
    editAction: "EDIT",
    changeAction: "Add Details",
    addDetailsSubTitle: "You can add name and phone number of the receiver.",
};

export const DEFAULT_MAX_IOS_VERSION_FOR_FOOD_PAGE_REDIRECTION = 461;
export const DELIVERY_ADDRESS_ID = "deliveryAddressId";
